var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ItemServico } from "./ItemServico";
import { useAuth } from "../../hooks/useAuth";
import { obterDadosCondutor } from "../../services/habilitacao.service";
export var SearchSection = function (_a) {
    var searchResults = _a.searchResults;
    var userInfo = useAuth().userInfo;
    var _b = useState(), data = _b[0], setData = _b[1];
    var isServiceAvalaible = function (service) {
        switch (service.title) {
            case 'Solicitar Renovação de CNH':
                if ((data === null || data === void 0 ? void 0 : data.processoRenovacao) === 'N')
                    return false;
                return true;
            case 'Solicitar troca da CNH temporária para CNH definitiva':
                if ((data === null || data === void 0 ? void 0 : data.processoDefinitiva) === 'N')
                    return false;
                return true;
            case 'Solicitar Segunda Via da CNH':
                if ((data === null || data === void 0 ? void 0 : data.processoSegundaVia) === 'N')
                    return false;
                return true;
            case 'Solicitar Abertura do Processo PID (Carteira Internacional)':
                if ((data === null || data === void 0 ? void 0 : data.processoPid) === 'N')
                    return false;
                return true;
            default:
                return true;
        }
    };
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _a.sent();
                        setData(response);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) && fetchDados();
    }, [data === null || data === void 0 ? void 0 : data.numeroRenach, userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    return (_jsx(Box, __assign({ display: "flex", flexDirection: "column", alignItems: "start", width: '100%' }, { children: searchResults.map(function (service, index) { return (_jsx(ItemServico, { category: service.category, title: service.title, subtitle: service.subtitle, goTo: service.goTo, isDisabled: !isServiceAvalaible(service) }, index)); }) })));
};
